export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e59ec60c817410880730693c1cd3477b.jpg"
          alt="MAHHERC background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col items-center text-center">
        <div className="inline-flex items-center gap-2 border border-white/30 rounded-full px-5 py-2 mb-8">
          <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
          <span className="text-white/80 text-xs uppercase tracking-widest font-medium">
            iOS Platform Specialists
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6 tracking-tight">
          Modern Applications
          <br />
          <span className="text-white/70">for the iOS Platform</span>
        </h1>

        <p className="text-base md:text-lg text-white/60 max-w-2xl leading-relaxed mb-12">
          MAHHERC is a team of experts crafting powerful iOS experiences — from
          privacy-focused VPN solutions to intelligent device optimization tools
          that redefine what mobile can do.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <div className="flex items-center gap-3 bg-white/10 border border-white/20 rounded-full px-6 py-3 backdrop-blur-sm">
            <i className="ri-shield-check-line text-green-400 text-lg w-5 h-5 flex items-center justify-center" />
            <span className="text-white/80 text-sm font-medium whitespace-nowrap">
              Security &amp; Privacy First
            </span>
          </div>
          <div className="flex items-center gap-3 bg-white/10 border border-white/20 rounded-full px-6 py-3 backdrop-blur-sm">
            <i className="ri-smartphone-line text-sky-400 text-lg w-5 h-5 flex items-center justify-center" />
            <span className="text-white/80 text-sm font-medium whitespace-nowrap">
              Native iOS Excellence
            </span>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/40 text-xs uppercase tracking-widest">
            Scroll
          </span>
          <i className="ri-arrow-down-line text-white/40 text-xl w-5 h-5 flex items-center justify-center" />
        </div>
      </div>
    </section>
  );
}
